<template>
  <div class="ActiveTab ValidationTab">
    <LocatieInformatieHeader :chargingpoint="chargingpoint">
      <h4>{{ $t('components.sidebar.Tabs.CommentsTab.title') }}</h4>
    </LocatieInformatieHeader>

    <div :class="['ActiveTab__Content', { isLockedForEditing }]">
      <b-alert
        :show="isLockedForEditing"
        variant="warning"
      >
        {{ $t(isLockedForEditingMessage, { case: processCaseRef }) }}
      </b-alert>
      <Comments :chargingpoint="chargingpoint" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LocatieInformatieHeader from '@/components/map/sidebar/LocatieInformatieHeader'
import Comments from '../Comments.vue'
import {
  EcoMovementLockedForEditingMessage,
  RHDHVBedrijventerreinenLockedForEditingMessage,
  RHDHVLockedForEditingMessage,
} from '@/services/commonMessages'
import { SOURCE } from '@/services/sourceTranslation'

export default {
  components: { LocatieInformatieHeader, Comments },
  computed: {
    ...mapGetters('planmode', {
      chargingpoint: 'getSelectedChargingpoint',
    }),
    ...mapGetters('config', ['getPhases']),

    prio() {
      return this.chargingpoint.prio
    },
    customPhase () {
      return this.getPhases.find(phase => phase.uuid === this.prio?.customPhase)?.label
    },
    isBoundToProcess () {
      if (this.chargingpoint.isVattenfallProcess) {
        return false
      }
      return !!this.chargingpoint.workflowCaseRef ||
            !!this.chargingpoint.workflowUuid ||
            !!this.chargingpoint.externalProcessId
    },
    isLockedForEditing () {
      return this.isBoundToProcess || this.chargingpoint.isLockedForEditing
    },
    processCaseRef() {
      return this.chargingpoint?.workflowCaseRef || this.chargingpoint?.externalProcessId
    },
    isLockedForEditingMessage () {
      if (this.isBoundToProcess) {
        return 'components.sidebar.Tabs.CommentsTab.editNotAllowed'
      }

      if (this.chargingpoint?.dataSource?.value === SOURCE.ECO_MOVEMENT) {
        return EcoMovementLockedForEditingMessage
      }

      // TOOLS-3285: Vastzetten palen met fase "Bedrijventerreinen GORAL"
      if (this.customPhase === 'Bedrijventerreinen GORAL') {
        return RHDHVBedrijventerreinenLockedForEditingMessage
      }

      return RHDHVLockedForEditingMessage
    },
  },
}
</script>

<style lang="scss">
.ActiveTab__Content {
  p {
    margin-bottom: .5rem
  }
}
</style>
